module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cf8f0e51849e00182a45b5bfd3a3e95a.png";